import React, { Suspense } from "react";
import "./App.css";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { AuthProvider } from "./services/authentication";
import { APPINSIGHTS_INSTRUMENTATIONKEY } from "./environmentVariables";
import TelemetryProvider from "./components/applicationinsights/TelemetryProvider";

import CallbackPage from "./pages/CallbackPage";
import SilentCallbackPage from "./pages/SilentCallbackPage";
import Layout from "./pages/Layout";
import {
    OIDC_REDIRECT_PATH,
    OIDC_SILENT_RENEW_PATH,
    OIDC_POST_LOGOUT_PATH
} from "./services/sso";
import OidcLogoutPage from "./pages/OidcLogoutPage";

const App: React.FC = () => {
    return (
        <Suspense fallback="loading">
            <BrowserRouter>
                <TelemetryProvider
                    instrumentationKey={APPINSIGHTS_INSTRUMENTATIONKEY}
                >
                    <AuthProvider>
                        <Switch>
                            <Route exact path={OIDC_REDIRECT_PATH}>
                                <CallbackPage />
                            </Route>

                            <Route exact path={OIDC_SILENT_RENEW_PATH}>
                                <SilentCallbackPage />
                            </Route>

                            <Route exact path={OIDC_POST_LOGOUT_PATH}>
                                <OidcLogoutPage />
                            </Route>

                            <Route>
                                <Layout />
                            </Route>
                        </Switch>
                    </AuthProvider>
                </TelemetryProvider>
            </BrowserRouter>
        </Suspense>
    );
};

export default App;
